import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { PayInResource } from './types';

export type Response = PayInResource;

export default (makeCall: MakeCall) =>
  (uuid: string, settlementReference: string) =>
    makeCall<Response>('PUT', `/api/v2/payment/pay-in/${uuid}/confirm`, {
      data: { settlementReference },
    });
